import React from 'react';
import {
    appName,
    contactEmail,
    contactNumber,
} from '../Constants';
import Footer from '../Footer';
import { useMenuItems } from '../menuItems';
import Navbar from '../Navbar';

const RefundsAndCancellations = () => {
    const { menuItems } = useMenuItems();
    return (
        <div className='font-sans antialiased bg-landing-white'>
            <Navbar menuItems={menuItems} />
            <section className='py-24 bg-gradient-to-br from-landing-slate-50 to-landing-white'>
                <div className='max-w-4xl mx-auto px-6'>
                    <div className='text-center mb-16'>
                        <span className='inline-flex items-center gap-2 bg-landing-blue-500/10 border border-landing-blue-500/20 rounded-full px-4 py-2 text-landing-blue-500 font-bold tracking-wide uppercase text-sm'>
                            Legal
                        </span>
                        <h1 className='text-4xl md:text-5xl font-bold text-landing-slate-900 mt-4 mb-6'>
                            Refund & Cancellation Policy
                        </h1>
                        <p className='text-xl text-landing-slate-600 max-w-2xl mx-auto leading-relaxed'>
                            Our policy for refunds and subscription
                            cancellations
                        </p>
                    </div>

                    <div className='bg-landing-white rounded-2xl p-8 shadow-sm border border-landing-gray-100'>
                        <p className='text-lg leading-relaxed'>
                            At {appName}, we strive to provide a seamless and
                            satisfactory experience with our credit purchasing
                            system. This refund policy outlines the conditions
                            under which credits purchased from our platform can
                            be refunded.
                        </p>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            1. Credits are Non-Refundable
                        </h2>
                        <p>
                            Please note that, generally, all purchases are
                            considered final and non-refundable. We do not offer
                            refunds or credits for partially used periods,
                            except as required by applicable laws in your
                            jurisdiction and certain criteria established by our
                            company.
                        </p>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            2. Refundable Circumstances
                        </h2>
                        <p>
                            Refunds will only be granted in special
                            circumstances like legality related to state laws.
                        </p>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            3. Process for Requesting a Refund
                        </h2>
                        <p>To request a refund, follow these steps:</p>
                        <ol className='list-decimal list-inside pl-5'>
                            <li>
                                Contact our customer support team at{' '}
                                <a
                                    href={`mailto:${contactEmail}`}
                                    className='text-landing-blue-600 hover:underline'
                                >
                                    {contactEmail}
                                </a>{' '}
                                or {contactNumber}.
                            </li>
                            <li>
                                Provide your purchase details, including the
                                transaction ID, purchase date, and the amount of
                                credits purchased.
                            </li>
                            <li>
                                Our team will review your request and respond
                                within 5-7 business days.
                            </li>
                        </ol>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            4. Refund Method
                        </h2>
                        <p>
                            Approved refunds will be processed back to the
                            original payment method used at the time of
                            purchase. Please allow 7-10 business days for the
                            refund to appear on your account, depending on your
                            financial institution.
                        </p>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            5. Disputes and Chargebacks
                        </h2>
                        <p>
                            If a chargeback is initiated on a credit purchase,
                            the credits associated with the chargeback will be
                            forfeited and your account may be subject to
                            suspension.
                        </p>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            6. Changes to This Policy
                        </h2>
                        <p>
                            {appName} reserves the right to amend this refund
                            policy at any time. Changes will be communicated via
                            email or through our website, and the effective date
                            will be updated accordingly.
                        </p>
                        <h2 className='text-2xl font-bold text-landing-slate-900 mt-8 mb-4'>
                            7. Contact Information
                        </h2>
                        <p>
                            If you have any questions or concerns about this
                            refund policy, please contact us at:
                        </p>
                        <ul className='list-disc list-inside pl-5'>
                            {contactEmail ? (
                                <li>
                                    Email:{' '}
                                    <a
                                        href={`mailto:${contactEmail}`}
                                        className='text-landing-blue-600 hover:underline'
                                    >
                                        {contactEmail}
                                    </a>
                                </li>
                            ) : (
                                <></>
                            )}
                            {contactNumber ? (
                                <li>Phone: {contactNumber}</li>
                            ) : (
                                <></>
                            )}
                        </ul>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default RefundsAndCancellations;
